import { useLayoutEffect, useState } from 'react'
import SelfieSvg from '@assets/img/svg/selfie.svg'
import SelfieDarkModeSvg from '@assets/img/svg/selfie-dark-mode.svg'
import ModalInstagramProfile from '../modal-instagram-profile/modal-instagram-profile'
import ModalVinculateFacebook from '../modal-vinculate-facebook/modal-vinculate-facebook'
import { useTranslation } from 'react-i18next'

import './importance.component.scoped.scss'
import './importance.component.scss'

export default () => {
  const [width, setWidth] = useState(window.innerWidth)
  const [height, setHeight] = useState(window.innerHeight)
  const [openModalInstagramProfile, setOpenModalInstagramProfile] = useState(false)
  const [openModalVinculateFacebook, setOpenModalVinculateFacebook] = useState(false)

  const { t } = useTranslation('modalVinculateSocialNetwork')

  useLayoutEffect(() => {
    const updateWidthAndHeight = () => {
      setWidth(window.innerWidth)
      setHeight(window.innerHeight)
    }

    window.addEventListener('resize', updateWidthAndHeight)

    return () => window.removeEventListener('resize', updateWidthAndHeight)
  })

  return (
    <>
      <div className="wrapper-importance" style={{ height: width < 991 ? `calc(${height}px - 141px)` : 'auto' }}>
        <img src={SelfieSvg} alt="Selfie" className="importance-selfie" />
        <img src={SelfieDarkModeSvg} alt="Selfie" className="importance-selfie-dark-mode" />
        <div className="importance-content">
          <h1>{t('connectInstagram')}</h1>
          <p>{t('toConnectInstagram')}</p>
          <p className="meta">{t('metaRequirement')}</p>
          <div className="link mt-5" role="button" tabIndex={0} onClick={() => setOpenModalInstagramProfile(true)}>
            <i className="fa-regular fa-circle-question" />
            <p>{t('instagramProfile')}?</p>
          </div>
          <div className="link" role="button" tabIndex={0} onClick={() => setOpenModalVinculateFacebook(true)}>
            <i className="fa-regular fa-circle-question" />
            <p>{t('vinculateFacebook')}?</p>
          </div>
        </div>
      </div>
      <ModalInstagramProfile openModal={openModalInstagramProfile} onCloseModal={() => setOpenModalInstagramProfile(false)} />
      <ModalVinculateFacebook openModal={openModalVinculateFacebook} onCloseModal={() => setOpenModalVinculateFacebook(false)} />
    </>
  )
}
